import {IMessageData, IObjectData, ISyncField, TBaseOrObservableType} from "../../../index";
import * as ko from "knockout";
import {createErrorMessage, getSyncField} from "../../../util/misc";
import PromiseRequest from "../../../req/PromiseRequest";
import {global} from "../../../appContext";
import {getSearchObjectParams} from "../../../util/request";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import from_syncfieldHtml from './from-syncfield.html?raw';

export let template: string = from_syncfieldHtml;

interface IParams {
    syncfield: ISyncField
    linkable?: TBaseOrObservableType<boolean>
}

export class viewModel {
    isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);

    private displayname!: string;
    private id!: number;
    private req: PromiseRequest = global.getPromiseRequest("searchobject");

    constructor(private params: IParams) {
        this.request();
    }

    protected request() {

        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE, type: "info"});

        const ruleset = {
            objecttype: {id: this.params.syncfield.referencefieldid},
            rules: [{
                argument: this.params.syncfield.value,
                argumentoperator: "Er lik",
                attribute: this.params.syncfield.referencefieldid,
            }]
        };

        const params = getSearchObjectParams({
            jruleset: JSON.stringify(ruleset),
            objecttypeid: this.params.syncfield.referencefieldid,
            resultsprpage: 1,
        });

        this.req
            .request(params)
            .then((data: IObjectData[]) => {
                this.messageData(null);
                const d = data[0];

                if (d) {
                    const sf = getSyncField("Department", d.syncfields);
                    if (sf) {
                        this.displayname = sf.value || sf.displayname || sf.name;
                    }
                    this.id = d.id;
                    this.isReady(true);
                } else {
                    this.messageData({message: "data not available", type: "warning"});
                }
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)));
            });
    }

}
